import axios from 'axios';
import { useEffect, useRef } from 'react';
import { getUrlVersion } from '../pages/commons/functions';

export function useTokenRefresh(refreshUrl: string, intervalMs: number = 15 * 60 * 1000) {
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const refreshToken = async () => {
            try {
                if (localStorage.getItem("JWT")) {
                    if (localStorage.getItem("JWT") !== "") {
                        const response = await axios.post(`${getUrlVersion()}/routing/v1/`,
                            {
                                data: "none"
                            },
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-routing': '/users/user/login',
                                    'JWT': localStorage.getItem("JWT"),
                                }
                            });

                        const data = response.data;
                        if (data) {
                            if (data.JWT && data.JWTRenew !== '') {
                                //console.log("newTOken")
                                //console.log(data.JWTRenew)
                                localStorage.setItem("JWT", data.JWTRenew)
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Token refresh failed:', error);
            }
        };

        // Call immediately once, then periodically
        //refreshToken();
        timerRef.current = setInterval(refreshToken, intervalMs);

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [refreshUrl, intervalMs]);
}